<template>
  <div class="footer-body">
    <ul class="footer-row">
      <li class="footer-row-el">
        <icon-arinet-footer
          :width="35"
          :height="31"
          style="margin-right: 50px;"
        ></icon-arinet-footer>
      </li>
      <li class="footer-row-el">
        <!-- <a href="#">{{ $t('footer.developers') }}</a> -->
      </li>
      <li class="footer-row-el">
        <!-- <a href="#">{{ $t('footer.advertising') }}</a> -->
      </li>
      <li class="footer-row-el">
        <!-- <a href="#">{{ $t('footer.legalInfo') }}</a> -->
      </li>
      <li class="footer-row-el">
        <!-- <a href="#">{{ $t('footer.dataProtection') }}</a> -->
      </li>
      <li class="footer-row-el"><router-link :to="{name:'Support'}">{{ $t('footer.techSupport') }}</router-link></li>
    </ul>
  </div>
</template>

<script>
import IconArinetFooter from "@/components/icons/IconArinetFooter";
export default {
  components: {
    IconArinetFooter,
  },
};
</script>

<style lang="scss">
.footer-row {
  background-color: var(--footer-background);
  margin: 0 auto;
  width: 1200px;
  list-style-type: none;
  display: flex;
  height: 52px;
  border-left: 1px solid var(--footer-border);
  border-bottom: 1px solid var(--footer-border);
  border-right: 1px solid var(--footer-border);
  padding: 0;
  box-shadow: 0px 4px 4px var(--box-shadow);
  justify-content: space-evenly;
  border-radius: 5px;
}
.footer-row li {
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  height: inherit;
  box-sizing: border-box;
  width: 100px;
}
.footer-row li a {
  font-family: Lato;
  color: var(--footer-text);
  font-size: 15px;
  text-decoration: none;
  font-weight: 400;
  line-height: 18px;
}
.footer-row-el a:hover {
  cursor: pointer;
  text-decoration: none;
  color: var(--footer-text-hover) !important;
}
</style>
